module.exports = __webpack_public_path__ + "static/burgermenu-30ed7761bd8f8de872403eece8bb31fe.png";